import { observable, computed, action, makeObservable } from "mobx";
import { VehicleModelData } from "../../ServicePlan/models/ServicePlanModels";

export default class CappedPricingServiceModel {
  @observable response: VehicleModelData[] = []; //this might change depening upon response
  @observable isServiceIntervalExist: boolean = false;
  @observable isRequestError: boolean = false;

  constructor() {
    makeObservable(this);
  }

  @computed get length() {
    return this.response ? this.response.length : 0;
  }

  @action reset = () => {
    this.response = null;
    this.isServiceIntervalExist = false;
    this.isRequestError = false;
  };
}
